/* ==========================================================================
   sk-cart-consent.js — keyboard access for Shopify's deferred-purchase consent.

   With accelerated checkout on, Shopify renders its buyer-consent line under the
   Checkout button ("...I agree to the cancellation policy..."). The words
   "cancellation policy" are a plain <span id="shopify-subscription-policy-button">
   with a click handler that opens the policy modal, so keyboard users can never
   reach it (QA-008). This gives that span a button's role, a tab stop and
   Enter/Space activation. It adds attributes only: the wording and the modal
   are Shopify's and are left alone.

   Shopify can inject or redraw the consent after this script runs, so the span
   is re-checked whenever the cart footer changes.
   ========================================================================== */

(function () {
  const TRIGGER_ID = 'shopify-subscription-policy-button';

  function enhance() {
    const trigger = document.getElementById(TRIGGER_ID);
    if (!trigger || trigger.dataset.skKeyboard) return;

    trigger.dataset.skKeyboard = 'true';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      trigger.click();
    });
  }

  function start() {
    enhance();
    const footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    new MutationObserver(enhance).observe(footer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
